export const ProductImage = [
    {
      id: 1,
      imageBG: "./images/image-product-1.jpg",
      image: "./images/image-product-1-thumbnail.jpg",
    },
    {
      id: 2,
      imageBG: "./images/image-product-2.jpg",
      image: "./images/image-product-2-thumbnail.jpg",
    },
    {
      id: 3,
      imageBG: "./images/image-product-3.jpg",
      image: "./images/image-product-3-thumbnail.jpg",
    },
    {
      id: 4,
      imageBG: "./images/image-product-4.jpg",
      image: "./images/image-product-4-thumbnail.jpg",
    },
  ];
  export const FirstProductImage = [
    {
      id: 1,
      imageBG: "./images/image-product-1.jpg",
      image: "./images/image-product-1-thumbnail.jpg",
    },
  ];